import { z } from 'zod';

import type { ActivityDefinition } from './types.js';

import { correctAnswerIssues, duplicateValueIssues, feedbackIssues, minimumOptions, optionIssues, requireOptions, trimmed, valuesOf } from './_checks.js';
import { draftFields, Option, questionFields } from './_shared.js';
import { asList } from './types.js';

/**
 * A multiple choice question with one answer. `correctAnswerSingle` holds an option's
 * value*; leaving it unset is legitimate (the question then routes rather than grades),
 * but setting it to something no option carries grades every answer wrong.
 */
export const multiChoiceSingleResponse: ActivityDefinition = {
  type: 'multi_choice_single_response',
  summary: 'A multiple choice question with one correct answer.',
  setup: z.looseObject({
    ...draftFields,
    ...questionFields,
    options: z.array(Option).optional(),
    correctAnswerSingle: z.string().optional(),
  }),
  check: (setup, ctx) => {
    const options = asList(setup.options);
    const issues = [
      ...requireOptions('multi_choice_single_response', options, ctx),
      ...minimumOptions('multi_choice_single_response', options, ctx),
      ...feedbackIssues('multi_choice_single_response', setup.feedback, ctx),
      ...optionIssues('multi_choice_single_response', options, ctx),
      ...duplicateValueIssues('multi_choice_single_response', options, ctx),
    ];

    issues.push(...correctAnswerIssues({
      type: 'multi_choice_single_response',
      field: 'correctAnswerSingle',
      answers: [trimmed(setup.correctAnswerSingle)],
      values: valuesOf(options),
      ctx,
    }));

    return issues;
  },
};
